<div>
  <div class="w-full custom-bg">
    <app-search-box
      (search)="onSearch($event)"
      [setSearch]="setSearch"
      class="flex w-full h-full items-center justify-center"
    >
    </app-search-box>
    <div class="bg-primary_tailwind bg-opacity-55">
      <!--<div *ngIf="!countsLoaded" class="spinner-container min-h-20">
        <div class="loading-spinner"></div>
      </div> -->
      <app-summary class="text-white"></app-summary>
    </div>
  </div>
  <div *ngIf="!searchValue || !searchValue.query">
    <div class="bg-white">
      <div class="flex flex-col justify-center items-center py-2">
        <div class="w-4/5">
          <h1>Welcome to Centinela</h1>
          <p class="text-justify">
            Centinela is a tool designed specifically to provide detailed academic information about
            Ecuadorian researchers, and offers users three types of searches to access this
            information. Its main objective is to streamline and facilitate the understanding of the
            findings and results of relevant scientific research, allowing researchers to explore
            the relationships and occurrences between keywords used in these studies.
          </p>
        </div>
      </div>
    </div>
    <div>
      <app-ecuador-contribution
        *ngIf="topicsLoaded"
        (t)="topicClcked($event)"
        [words]="words"
        [provinces]="provinces"
      ></app-ecuador-contribution>
    </div>
  </div>
</div>
<div class="w-full flex justify-center items-center">
  <div
    *ngIf="searchValue && searchValue.query"
    [ngSwitch]="searchValue.option"
    class="flex pb-5 flex-col justify-center items-center md:flex-row w-full"
  >
    <!--    <app-filter-sidebar class="w-1/4" [code]="searchValue.option"  [ngClass]="{'hidden':isAuthorSearch()}" ></app-filter-sidebar>-->
    <div class="w-5/6" [ngClass]="{ 'w-full': isAuthorSearch() }">
      <div>
        <!-- Most Relevant Authors Results -->
        <app-article-information *ngSwitchCase="'mrar'" query="{{ searchValue.query }}" />
        <!-- Author Results -->
        <app-author-retrieve class="p-2" *ngSwitchCase="'au'" query="{{ searchValue.query }}" />
        <!-- Most Relevant Articles Results -->
        <app-most-relevant-authors-graph
          class="p-2"
          *ngSwitchCase="'mrau'"
          [query]="searchValue.query"
        />
      </div>
    </div>
  </div>
</div>
